import { required } from "vuelidate/lib/validators";
import { BaseModel } from "@/models/BaseModel";

export class Preset extends BaseModel {
  constructor({
    id = null,
    creation_date,
    name,
    is_default = false,
    competencies = [],
    infos = [],
    questionnaires = [],
    threats = []
  }) {
    super();

    this.id = id;
    this.creation_date = creation_date;
    this.name = name;
    this.is_default = is_default;
    this.competencies = competencies; // TODO: Use models?
    this.infos = infos; // TODO: Use models?
    this.questionnaires = questionnaires; // TODO: Use models?
    this.threats = threats; // TODO: Use models?
  }

  static get validations() {
    const validations = {
      name: {
        required
      }
    };

    return validations;
  }
}

export default Preset;
